import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SettingsLicenseStore } from 'src/stores/SettingsStores/SettingsLicenseStore/SettingsLicenseStore';
import { DateHelper } from 'src/utils/DateHelper';
import styled from 'styled-components';

const store = SettingsLicenseStore;

export const LicenseExpirationWarning = observer(() => {
    const { t } = useTranslation();

    useEffect(() => {
        store.loadItem('');
    }, []);

    if (!store.isLicenseExpiring) {
        return null;
    }

    const expirationDate = DateHelper.formatDate(store.licenseExpirationDate);

    return (
        <StyledWarning>
            <WarningText>
                {t('App.License.ExpirationWarning', { expirationDate })}
            </WarningText>
        </StyledWarning>
    );
});

const StyledWarning = styled.div`
    background-color: #fbc024;
    padding: 0.5rem 1.5rem;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
`;

const WarningText = styled.div`
    color: #0d0f1c;
    font-size: 0.8125rem;
    line-height: 1.3;
    text-align: center;
`;
